import React from 'react';
import './index.scss'
import { AppHeader, AppFooter } from '@/components'
import { Route} from 'react-router-dom'
import EngineeringDesign from './EngineeringDesign/index'
import WholeProcess from './WholeProcess/index'
import InvestmentConsultation from './InvestmentConsultation/index'
import Tendering from './Tendering/index'
import Cost from './Cost/index'
import Risk from './Risk/index'
import Finance from './Finance/index'
import { NavBars, NavContainer } from '@/components/mixins'
import { cookieUtil } from '@/assets/js/cookie'
let Swiper = window.Swiper
const $ = window.$;
class ProductDetails extends React.PureComponent {
  constructor () {
    super()
    this.state = {
      title: [
        {
          name: '全过程工程咨询',
          id: '0',
          url: '/WholeProcess'
        },
        {
          name: '投资咨询',
          id: '1',
          url: '/InvestmentConsultation'
        },
        {
          name: '工程设计',
          id: '2',
          url: '/EngineeringDesign'
        },
        {
          name: '采购与招标代理',
          id: '3',
          url: '/Tendering'
        },
        {
          name: '工程造价咨询',
          id: '4',
          url: '/Cost'
        },
        {
          name: '项目风险管控',
          id: '5',
          url: '/Risk'
        },
        {
          name: '工程财务咨询',
          id: '6',
          url: '/Finance'
        }
      ],
      navSwiper: '',
      NavBarsData: {
        title: '工程咨询产品全过程工程产品服务线',
        rootPath: '/Products/ProductDetails'
      },
      showNav: false,
      Ifscroll: false,
      scrollTop: 0
    }
  }
  componentDidMount() {
    const that = this
    const showNav = cookieUtil.get('showNav') || false
    // 初始化 -- 需要延时
    this.setState({
      navSwiper: new Swiper('#tab-container', {
        speed: 500,
        autoHeight: true,
        lazy: {
          loadOnTransitionStart: true
        },
        on: {
          slideChangeTransitionStart: function () {
            const scrollTop = $(window).scrollTop();
            for (let index = 0; index < that.state.title.length; index++) {
              const item = that.state.title[index];
              if (index === this.activeIndex) {
                const pathname = '/Products/ProductDetails' + item.url
                // 获取最里面的值 -- 为了和点击时获取元素对应
                const dom = document.getElementsByClassName('navbars-title')[this.activeIndex].getElementsByTagName('a')[0];
                that.handlePosition(dom)
                that.props.history.push(pathname)
                break;
              }
            }
            that.state.navSwiper.slideTo(this.activeIndex, 1000, false);
            const top1 = document.getElementsByClassName('nav-container')[0].clientHeight;
            if (scrollTop >= top1) {
              window.scrollTo(0, top1);
            }
          }
        }
      }),
      showNav: showNav
    })
      // this.handleRouterUrl();
    that.stickFn ();
  }
  stickFn () {
    const top1 = document.getElementsByClassName('top')[0];
    const top2 = document.getElementsByClassName('nav-container')[0].clientHeight;
    const fixedHeight = top1.clientHeight + top2;
    $(window).scroll(function () {
      var scroH = $(this).scrollTop();
      if (scroH >= fixedHeight) {
        $(".nav-container").css({ "position": "fixed", "top": 0,"left" : 0 ,'zIndex':3,"width":'100%',"background":'#fff','overflow':'auto'});
      } else{
        $(".nav-container").css({ "position": "relative" });
      }
    })
  }
  componentDidUpdate () {
    // 路由点击时
    this.handleRouterUrl()
  }
  handleRouterUrl () {
    for (let index = 0; index < this.state.title.length; index++) {
      const item = this.state.title[index];
      const pathname = this.props.location.pathname
      if (pathname.includes(item.url)) {
        // this.props.history.push(pathname)
        this.state.navSwiper.slideTo(index)
        break;
      }
    }
  }
  componentWillUnmount () {
    cookieUtil.unset('showNav')
  }
  // handleNavToggle (e, value) {
  //   this.state.navSwiper.slideTo(value)
  //   // 点击会获得最里面的值
  //   const ev = e || window.event;
  //   const target = ev.target || ev.srcElement;
  //   this.handlePosition(target)
  // }
  handlePosition (dom) {
    const that = $(dom)
    console.log(that, 'df')
    const moveX = that.position().left + that.parent().parent().scrollLeft();
    // console.log(that.parent().parent().scrollLeft(), 'that.parent().parent().parent()')
    const pageX = document.documentElement.clientWidth;
    const blockWidth = that.width();
    const left = moveX - (pageX / 2) + blockWidth / 2;
    // console.log(moveX, 'move')
    // console.log(pageX, 'pageX')
    // console.log(blockWidth, 'df')
    // console.log(left)
    $('.details-nav').scrollLeft(left)
  }
  handleShowNav () {
    if (cookieUtil.get('showNav')) {
      // 有时候跳转感觉没执行下面
      this.props.history.push('/')
    } else {
      this.setState({
        showNav: !this.state.showNav
      }, () => {
        this.preventScroll()
      })
    }
    cookieUtil.unset('showNav')
    // console.log(this.state.showNav, '是否点击')
  }
  preventScroll () {
    const that = this
    if (this.state.showNav) {
      var scrolltop = that.getScrollTop()
      this.setState({
        scrollTop: scrolltop
      })
      document.body.classList.add('dialog-open')
      document.body.style.top = scrolltop
    } else {
      document.body.classList.remove('dialog-open');
      that.to(this.state.scrollTop)
    }
  }
  getScrollTop () {
    return document.documentElement.scrollTop || document.body.scrollTop
  }
  to(scrollTop) {
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop
  }
  render(){
    return (
      <div className="ProductDetails">
        <Route component={AppHeader} />
        <div className="nav-container">
          <span className="nav-small-icon" onClick={(e) => this.handleShowNav(e)}>
            <svg width='100%' height="100%">
              <rect width="40%" height="40%" x="0" y="0" style={{fill:'rgb(255,255,255)',strokeWidth:1, stroke:'rgb(0,0,0)'}}/>
              <rect width="40%" height="40%" x="55%" y="0" style={{fill:'rgb(255,255,255)',strokeWidth:1, stroke:'rgb(0,0,0)'}}/>
              <rect width="40%" height="40%" x="0" y="55%" style={{fill:'rgb(255,255,255)',strokeWidth:1, stroke:'rgb(0,0,0)'}}/>
              <rect width="40%" height="40%" x="55%" y="55%" style={{fill:'rgb(255,255,255)',strokeWidth:1, stroke:'rgb(0,0,0)'}}/>
            </svg>
          </span>
          {/* <ul className="details-nav">
            {
              this.state.title.map((item, index) =>
                <li className="produce-title" key={index}>
                  <NavLink to={'/Products/ProductDetails'+item.url}
                  activeClassName="active" onClick={(e) => this.handleNavToggle(e, item.id)}>{item.name}</NavLink>
                </li>
              )
            }
          </ul> */}
          <NavContainer title={this.state.title} NavBarsData={this.state.NavBarsData}></NavContainer>

        </div>
        <section className="swiper-container" id="tab-container" >
          <div className="swiper-wrapper" >
            <article className="swiper-slide" >
              <WholeProcess></WholeProcess>
            </article>
            <article className="swiper-slide" >
              <InvestmentConsultation></InvestmentConsultation>
            </article>
            <article className="swiper-slide" >
              <EngineeringDesign></EngineeringDesign>
            </article>
            <article className="swiper-slide" >
              <Tendering></Tendering>
            </article>
            <article className="swiper-slide" >
              <Cost></Cost>
            </article>
            <article className="swiper-slide" >
              <Risk></Risk>
            </article>
            <article className="swiper-slide" >
              <Finance></Finance>
            </article>

          </div>
        </section>
        <Route component={AppFooter} />
        {this.state.showNav ?
          <NavBars NavBarsData={this.state.NavBarsData} NavBarData={this.state.title}
            handleShowNav={this.handleShowNav.bind(this)}></NavBars> : ''
        }
      </div>
    )
  }
}
export default ProductDetails
